import { isEmpty } from 'lodash'
import * as ActionTypes from '../ActionTypes'
import { TRANSITIONS } from '~/enums'
import { ASSET_SIZE_STATUS } from '~/config/constants/asset'
import { getTransitionDissolveInsertStatus } from '~/helpers/assets/getTransitionDissolveInsertStatus'

const getPermissions = (state, transitionParams, newTransitionDuration, isIncrease) => {
  let isAllowed = true
  const forChangesAssetsMap = new Map()
  const transitionData = { ...transitionParams }
  if (!isEmpty(transitionData)) {
    for (const trId of Object.keys(transitionData)) {
      const {
        rightAssetId,
        leftAssetId,
        diff,
        transitionType,
        transitionAsset,
      } = transitionData[trId]
      const rightAsset = state.layer.assets.find(a => a.id === rightAssetId)
      const leftAsset = state.layer.assets.find(a => a.id === leftAssetId)

      const existsFadeOutDuration = state.layer
        .assets.find(a => [ TRANSITIONS.FADEOUT, TRANSITIONS.DISSOLVE ].includes(a.type)
        && a.leftVideoAssetId === rightAssetId)?.duration ?? 0
      const existsFadeInDuration = state.layer
        .assets.find(a => [ TRANSITIONS.FADEIN, TRANSITIONS.DISSOLVE ].includes(a.type)
        && a.rightVideoAssetId === leftAssetId)?.duration ?? 0

      if (rightAsset && leftAsset && transitionType === TRANSITIONS.DISSOLVE) { // DISSOLVE
        const status = getTransitionDissolveInsertStatus(state.layer.assets, leftAsset,
          rightAsset, transitionAsset, diff)
        if (isIncrease) {
          if (status === ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_CUT) {
            forChangesAssetsMap
              .set(trId, {
                next: {
                  startTime: rightAsset.startTime - (diff / 2),
                  duration: transitionAsset.duration + diff,
                },
                prev: {
                  startTime: rightAsset.startTime,
                  duration: transitionAsset.duration,
                },
              })
              .set(rightAssetId, {
                next: {
                  startTime: rightAsset.startTime - (diff / 2),
                  mediaStart: rightAsset.mediaStart - (diff / 2),
                  duration: rightAsset.duration + (diff / 2),
                },
                prev: {
                  startTime: rightAsset.startTime,
                  mediaStart: rightAsset.mediaStart,
                  duration: rightAsset.duration,
                },
              })
              .set(leftAssetId, {
                next: { duration: leftAsset.duration + (diff / 2) },
                prev: { duration: leftAsset.duration },
              })
          } else if (status === ASSET_SIZE_STATUS.RIGHT_CUT_LEFT_NORMAL) {
            const isRightIntersectionAssetBoundaries = leftAsset.duration + diff
              <= rightAsset.endTime
            if (isRightIntersectionAssetBoundaries) {
              forChangesAssetsMap
                .set(trId, {
                  next: {
                    startTime: rightAsset.startTime - diff,
                    duration: transitionAsset.duration + diff,
                  },
                  prev: {
                    startTime: rightAsset.startTime,
                    duration: transitionAsset.duration,
                  },
                })
                .set(rightAssetId, {
                  next: {
                    startTime: rightAsset.startTime - diff,
                    mediaStart: rightAsset.mediaStart - diff,
                    duration: rightAsset.duration + (diff / 2),
                  },
                  prev: {
                    startTime: rightAsset.startTime,
                    mediaStart: rightAsset.mediaStart,
                    duration: rightAsset.duration,
                  },
                })
            } else {
              isAllowed = false
            }
          } else if (status === ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_NORMAL) {
            const isLeftIntersectionAssetBoundaries = leftAsset.startTime
              >= rightAsset.startTime - diff
              && rightAsset.startTime - diff > 0
            if (!isLeftIntersectionAssetBoundaries) {
              forChangesAssetsMap
                .set(trId, {
                  next: {
                    startTime: rightAsset.startTime,
                    duration: transitionAsset.duration + diff,
                  },
                  prev: {
                    startTime: rightAsset.startTime,
                    duration: transitionAsset.duration,
                  },
                })
                .set(leftAssetId, {
                  next: { duration: leftAsset.duration + diff },
                  prev: { duration: leftAsset.duration },
                })
            } else {
              isAllowed = false
            }
          } else if (status === ASSET_SIZE_STATUS.NOT_CUT) {
            forChangesAssetsMap
              .set(trId, {
                next: {
                  startTime: rightAsset.startTime - diff,
                  duration: transitionAsset.duration + diff,
                },
                prev: {
                  startTime: rightAsset.startTime,
                  duration: transitionAsset.duration,
                },
              })
              .set(rightAssetId, {
                next: { startTime: rightAsset.startTime - diff },
                prev: { startTime: rightAsset.startTime },
              })
          } else {
            isAllowed = false
            break
          }
        } else {
          forChangesAssetsMap
            .set(trId, {
              next: {
                startTime: rightAsset.startTime + (diff / 2) * -1,
                duration: transitionAsset.duration - diff * -1,
              },
              prev: {
                startTime: rightAsset.startTime,
                duration: transitionAsset.duration,
              },
            })
            .set(rightAssetId, {
              next: {
                startTime: rightAsset.startTime + (diff / 2) * -1,
                mediaStart: rightAsset.mediaStart + (diff / 2) * -1,
                duration: rightAsset.duration - (diff / 2) * -1,
              },
              prev: {
                startTime: rightAsset.startTime,
                mediaStart: rightAsset.mediaStart,
                duration: rightAsset.duration,
              },
            })
            .set(leftAssetId, {
              next: { duration: leftAsset.duration - (diff / 2) * -1 },
              prev: { duration: leftAsset.duration },
            })
        }
      } else if (rightAsset && transitionType === TRANSITIONS.FADEIN) { // FADE_IN
        if ((rightAsset.duration - existsFadeOutDuration) >= newTransitionDuration) {
          forChangesAssetsMap
            .set(trId, {
              next: { duration: transitionAsset.duration + diff },
              prev: { duration: transitionAsset.duration },
            })
        } else {
          isAllowed = false
          break
        }
      } else if (leftAsset && transitionType === TRANSITIONS.FADEOUT) { // FADE_OUT
        if ((leftAsset.duration - existsFadeInDuration) >= newTransitionDuration) {
          forChangesAssetsMap
            .set(trId, {
              next: {
                startTime: transitionAsset.startTime - diff,
                duration: transitionAsset.duration + diff,
              },
              prev: {
                startTime: transitionAsset.startTime,
                duration: transitionAsset.duration,
              },
            })
        } else {
          isAllowed = false
          break
        }
      }
      // eslint-disable-next-line no-param-reassign
      transitionData[trId] = {
        ...transitionData[trId],
        rightAsset,
        leftAsset,
      }
    }
  }
  return { isAllowed, transitionData, forChangesAssetsMap }
}

export const patchTransition = (asset, patch, options, dispatch, getState) => {
  if (patch.duration) {
    const state = getState()
    const transition = asset
    const newTransitionDuration = patch.duration
    const { applyToAll } = patch

    const transitionParams = {}
    if (applyToAll) {
      state.layer.assets.forEach(tr => {
        if (asset.type === tr.type) {
          transitionParams[tr.id] = {
            leftAssetId: tr.leftVideoAssetId,
            rightAssetId: tr.rightVideoAssetId,
            prevDuration: tr.duration,
            diff: newTransitionDuration - tr.duration,
            transitionType: tr.type,
            transitionId: tr.id,
            transitionAsset: tr,
          }
        }
      })
    } else {
      transitionParams[transition.id] = {
        leftAssetId: transition.leftVideoAssetId,
        rightAssetId: transition.rightVideoAssetId,
        prevDuration: transition.duration,
        diff: newTransitionDuration - transition.duration,
        transitionType: transition.type,
        transitionId: transition.id,
        transitionAsset: transition,
      }
    }
    const increment = newTransitionDuration - transition.duration
    const isIncrease = increment > 0

    const {
      isAllowed, forChangesAssetsMap,
    } = getPermissions(state, transitionParams, newTransitionDuration, isIncrease)

    if (isAllowed) {
      dispatch(transitionDurationChangeAction(forChangesAssetsMap))
    }
  }
}

export function transitionDurationChangeAction(forChangesAssetsMap, isRollback = false) {
  return ({
    type: ActionTypes.TRANSITION_DURATION_CHANGE,
    payload: {
      forChangesAssetsMap,
      isRollback,
    },
  })
}
